import React from 'react';
import classes from './researchitem.module.css'

const ResearchItem = () => {
    return (
        <div className={ classes.item }>
            <p className={ classes.workinprogress }>Coming soon</p>
        </div>
    );
}

export default ResearchItem;